module.exports = __webpack_public_path__ + "static/media/cs-retro.3f135667.jpg";